import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-text": "正在加载数据，请稍候" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 退回节点")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "fc-d" }, null, -1)
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = { style: {"text-align":"center"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 提 交 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';

import { GbDialog } from '@/components/GbDialog/Index';

/* Apis */
import { CtRejectApi, GetTurnBackNodesApi } from '../../../apis/contract/contract.api';

/* Dtos */
import { CtAuditDto } from '../../../apis/contract/contract.type';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const elFormRef = ref<ComponentRef<typeof ElForm>>();

const state = reactive({
	show: false,
	loading: false,
	loadNode: false,
	detail: {} as any,
	nodeList: [] as any[],
	title: '审批退回',
});

const formRules = reactive<FormRules>({
	node_v_id: [{ required: true, message: '请选择退回节点', trigger: 'blur' }],
	remark: [{ required: true, message: '审核批示不能为空', trigger: 'blur' }],
});

const schema = reactive<any>({
	id: '',
	revision: '',
	remark: '',
});

const load = {
	getTurnBackNodeList: async (contractId: string) => {
		state.loadNode = true;
		const { data } = await GetTurnBackNodesApi(contractId);
		state.nodeList = data || [];
		state.loadNode = false;
	},
};

const actions = {
	/* 审批退回 */
	reject: () => {
		unref(elFormRef)?.validate(async (isValid: boolean) => {
			if (!isValid) return;

			state.loading = true;

			const formData = unref(schema);
			const { succeeded, errors } = await CtRejectApi(formData);

			if (!succeeded) {
				ElMessage.error(errors);
			} else {
				ElMessage.success('提交审批成功。');

				$emits('refresh', succeeded);
				state.show = false;
			}

			state.loading = false;
		});
	},

	/* 选择退回的节点 */
	onNodeChange: (val: any) => {
		unref(schema).node_id = `${val.nodeID}`;
		unref(schema).back_empno = val.empno;
	},
};

/* 打开对话框 */
const showDialog = (contract: any, isCancel: boolean) => {
	unref(schema).id = contract.id;
	unref(schema).revision = contract.revision;
	unref(schema).is_cancel = isCancel; // 是否作废

	load.getTurnBackNodeList(contract.id);

	state.detail = contract;
	state.show = true;
};

expose({ showDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(state).show) = $event)),
    title: _unref(state).title,
    style: {"width":"520px"}
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: actions.reject
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            type: "info",
            size: "small",
            style: {"width":"80px"},
            disabled: _unref(state).loading,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).show = false))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: _unref(schema),
          "label-position": "top",
          rules: _unref(formRules),
          size: "small"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "合同编号" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.no,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).detail.no) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "合同名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(state).detail.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).detail.name) = $event)),
                  disabled: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (!_unref(schema).is_cancel)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  prop: "node_v_id"
                }, {
                  label: _withCtx(() => [
                    _hoisted_2,
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      style: {"width":"100%"},
                      modelValue: _unref(schema).node_v_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(schema).node_v_id) = $event)),
                      "value-key": "id",
                      clearable: "",
                      loading: _unref(state).loadNode,
                      disabled: _unref(state).loadNode,
                      onChange: actions.onNodeChange
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).nodeList, (node) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: node.id,
                            label: `节点【${node.name}】，人员：${node.empName}(${node.empno})`,
                            value: node
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "loading", "disabled", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "审批意见",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(schema).remark,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(schema).remark) = $event)),
                  type: "textarea",
                  "show-word-limit": "",
                  rows: "4",
                  maxlength: "150",
                  placeholder: "请输入审批意见"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})